import { render } from "./MainPage.vue?vue&type=template&id=615aeed6&scoped=true"
import script from "./MainPage.vue?vue&type=script&lang=js"
export * from "./MainPage.vue?vue&type=script&lang=js"

import "./MainPage.vue?vue&type=style&index=0&id=615aeed6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abela\\Documents\\Projects\\SmartTile\\gympass-web-vue\\gympass-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-615aeed6"]])

export default __exports__